export default "__VITE_ASSET__DOKp0n0U__"